import { ReportName } from '@/types/reports.types'

export const REPORT_TABS: { name: ReportName; labelKey: string }[] = [
  { name: ReportName.OPERATIONS, labelKey: 'aab.company.reporting.operations.tab.title' },
  { name: ReportName.EMPLOYEES, labelKey: 'aab.company.reporting.employees.tab.title' },
  { name: ReportName.ORDER_ITEMS, labelKey: 'aab.company.reporting.bookings.tab.title' }
]

export const QUICKSIGHT_FRAME_HEIGHT = '600px'
export const QUICKSIGHT_FRAME_WIDTH = '100%'
